import MarkdownIt from 'markdown-it'
import { isImageBedUrl, PLACEHOLDER_SRC } from './imagebed'

const md = new MarkdownIt({
  html: false,        // 禁用原始 HTML，防 XSS
  linkify: true,
  breaks: true,
})

// 链接新窗口打开
const defaultRender = md.renderer.rules.link_open || function (tokens, idx, options, env, self) {
  return self.renderToken(tokens, idx, options)
}
md.renderer.rules.link_open = function (tokens, idx, options, env, self) {
  const href = tokens[idx].attrGet('href') || ''
  // 站内用户提及 [@用户名](/u/123)：交给前端拦截弹资料卡，不新开标签页
  const mention = href.match(/^\/u\/(\d+)$/)
  if (mention) {
    tokens[idx].attrSet('class', 'mention')
    tokens[idx].attrSet('data-uid', mention[1])
  } else {
    tokens[idx].attrSet('target', '_blank')
    tokens[idx].attrSet('rel', 'noopener noreferrer')
  }
  return defaultRender(tokens, idx, options, env, self)
}

const defaultImageRender = md.renderer.rules.image || function (tokens, idx, options, env, self) {
  return self.renderToken(tokens, idx, options)
}
md.renderer.rules.image = function (tokens, idx, options, env, self) {
  const token = tokens[idx]
  const src = token.attrGet('src') || ''
  if (isImageBedUrl(src)) {
    token.attrSet('data-imagebed-src', src)
    token.attrSet('src', PLACEHOLDER_SRC)
    token.attrJoin('class', 'imagebed-loading')
    token.attrSet('loading', 'lazy')
    // 渲染阶段先输出占位 src + loading class，避免浏览器先请求加密字节出现黑块；
    // 后续由 imagebed.js 的 hydrateImageElement 解密后用 blob URL 替换。
  }
  return defaultImageRender(tokens, idx, options, env, self)
}

export function renderMarkdown(text) {
  if (!text) return ''
  return md.render(text)
}

export function extractMarkdownLinks(text) {
  if (!text) return []

  const seen = new Set()
  const result = []
  const tokens = md.parse(text, {})

  tokens.forEach((token) => {
    if (token.type !== 'inline' || !Array.isArray(token.children)) return
    token.children.forEach((child) => {
      if (child.type !== 'link_open') return
      const href = child.attrGet('href') || ''
      if (!/^https?:\/\//i.test(href)) return
      if (seen.has(href)) return
      seen.add(href)
      result.push(href)
    })
  })

  return result
}

// 行内渲染（无 <p> 包裹，用于签名等紧凑展示；linkify 仍会把裸域名转成可点链接）
export function renderInline(text) {
  if (!text) return ''
  return md.renderInline(text)
}

export default md
